import { render, staticRenderFns } from "./LayoutCopyMatchDialog.vue?vue&type=template&id=74648768"
import script from "./LayoutCopyMatchDialog.vue?vue&type=script&lang=js"
export * from "./LayoutCopyMatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports